import { Box, Divider, Flex, Text } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { ReactNode, useState } from "react";

interface SidePanelAccordionProps {
  icon: IconType;
  iconBgColor: string;
  iconColor: string;
  title: string;
  subtitle?: string;
  activeCount: number;
  defaultOpen?: boolean;
  children: ReactNode;
}

export function SidePanelAccordion({
  icon: Icon,
  iconBgColor,
  iconColor,
  title,
  subtitle,
  activeCount,
  defaultOpen = true,
  children
}: SidePanelAccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Box
      bg="rgba(255,255,255,0.6)"
      borderRadius="12px"
      overflow={isOpen ? "visible" : "hidden"}
      boxShadow="0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)"
    >
      <Flex
        align="center"
        justify="space-between"
        px="14px"
        py="12px"
        cursor="pointer"
        userSelect="none"
        onClick={() => setIsOpen((prev) => !prev)}
        _hover={{ bg: "#F8FAFC" }}
        transition="background 0.15s"
      >
        <Flex align="center" gap="10px" flex={1} minW={0}>
          <Flex
            w="38px"
            h="38px"
            borderRadius="10px"
            bg={iconBgColor}
            align="center"
            justify="center"
            flexShrink={0}
          >
            <Icon size={18} color={iconColor} />
          </Flex>

          <Box flex={1} minW={0}>
            <Flex align="center" gap="8px">
              <Text
                fontSize="14px"
                fontWeight="700"
                color="#1E293B"
                noOfLines={1}
              >
                {title}
              </Text>
              {activeCount > 0 && (
                <Box
                  px="8px"
                  py="2px"
                  borderRadius="full"
                  bg="#EFF6FF"
                  border="1px solid #BFDBFE"
                  flexShrink={0}
                >
                  <Text fontSize="11px" fontWeight="600" color="#2563EB">
                    {activeCount} {activeCount === 1 ? "ativo" : "ativos"}
                  </Text>
                </Box>
              )}
            </Flex>
            {subtitle && (
              <Text
                fontSize="12px"
                color="#90a1b9"
                fontWeight="400"
                noOfLines={1}
              >
                {subtitle}
              </Text>
            )}
          </Box>
        </Flex>

        <Box color="#90a1b9" flexShrink={0} ml="8px">
          {isOpen ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
        </Box>
      </Flex>

      {isOpen && (
        <>
          <Divider borderColor="#F1F5F9" my="0px" />
          <Box px="12px" py="12px">
            {children}
          </Box>
        </>
      )}
    </Box>
  );
}
